import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-field mb-4" }
const _hoisted_2 = { class: "p-label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "1920",
  height: "1440",
  fill: "#ECEDF3"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "p-field-checkbox-label",
  for: "binary"
}
const _hoisted_8 = {
  class: "p-field-checkbox-label",
  for: "binary"
}
const _hoisted_9 = { class: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.handleSubmit(!$setup.v$.$invalid)), ["prevent"])),
    class: "_relative"
  }, [
    ($setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          isOverlay: ""
        }))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('company_page.allowed_angles')), 1)
    ]),
    (!$setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_VueDraggableNext, {
          key: 1,
          class: "grid _relative",
          modelValue: $setup.state.data.angles,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.angles) = $event)),
          onChange: $setup.onDragChange
        }, {
          default: _withCtx(() => [
            _createVNode(_TransitionGroup, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.angles, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "col-12 md:col-6 lg:col-3"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([[_ctx.$style.card, item.isSelected ? _ctx.$style.cardselected : ''], "flex flex-column align-items-center"]),
                      onClick: (e) => $setup.toggleSelectAngle(e, item)
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(_ctx.$style.substrate),
                        width: "1920",
                        height: "1440",
                        viewBox: "0 0 1920 1440",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_5, 2)),
                      _createElementVNode("img", {
                        src: item.processed_url || item.loaded_photo || item.car,
                        class: _normalizeClass([_ctx.$style.image, !(item.processed_url || item.loaded_photo) && _ctx.$style.imageReference]),
                        alt: ""
                      }, null, 10, _hoisted_6),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex align-items-center w-full mb-5", _ctx.$style.actions])
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass([_ctx.$style.position, "py-1 px-3 mr-2 _button-2"])
                        }, _toDisplayString(item.index), 3),
                        _createElementVNode("p", {
                          class: _normalizeClass([_ctx.$style.position, "py-1 px-3 _button-2"])
                        }, _toDisplayString(item.type), 3)
                      ], 2),
                      (item.isSelected)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(_ctx.$style.checkboxContainer)
                          }, [
                            _createElementVNode("label", {
                              class: _normalizeClass([_ctx.$style.checkbox, "p-field-checkbox mr-5"]),
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onToggleWithLogo && $setup.onToggleWithLogo(...args)))
                            }, [
                              _createVNode(_component_Checkbox, {
                                modelValue: item.show_logo,
                                "onUpdate:modelValue": ($event: any) => ((item.show_logo) = $event),
                                binary: true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('company_page.show_logo')), 1)
                            ], 2),
                            _createElementVNode("label", {
                              class: _normalizeClass([_ctx.$style.checkbox, "p-field-checkbox mr-5"]),
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onToggleWithBanner && $setup.onToggleWithBanner(...args)))
                            }, [
                              _createVNode(_component_Checkbox, {
                                modelValue: item.show_banner,
                                "onUpdate:modelValue": ($event: any) => ((item.show_banner) = $event),
                                binary: true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('company_page.show_banner')), 1)
                            ], 2)
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_3)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Button, {
        class: "p-button-big col-6 mt-3 ml-2 mr-2",
        type: "submit",
        disabled: $setup.notChanged || $setup.state.isSubmiting
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('save_change')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 32))
}